import { specialAwards } from './content'

// Reading groups, not additional awards or judging criteria.
const awardGroups = [
  { title: 'ความงามและบุคลิกภาพ', awards: [0, 1, 3, 5] },
  { title: 'สุขภาพและพลังความคิด', awards: [2, 8, 9] },
  { title: 'มิตรภาพและพลังการสื่อสาร', awards: [4, 6, 7, 10] },
]

export default function SpecialAwards() {
  return <section className="awards-collection" id="special-awards" aria-labelledby="special-awards-title">
    <div className="awards-collection-intro">
      <p className="eyebrow">SPECIAL AWARDS</p>
      <span className="awards-collection-count" aria-hidden="true">11</span>
      <h3 id="special-awards-title"><span className="sr-only">11 </span>รางวัลพิเศษ<br /><em>ความโดดเด่นในแบบคุณ</em></h3>
      <p>เพราะศักยภาพของผู้หญิง<br />มีความหมายในหลายมิติ</p>
      <span className="awards-collection-hint">เลือกรายการเพื่อดูรางวัลในแต่ละด้าน</span>
    </div>
    <div className="award-categories">{awardGroups.map((group, index) => <details className="award-category" key={group.title} name="empress-special-awards" open={index === 0}>
      <summary><span className="award-category-heading"><span className="award-category-index" aria-hidden="true">0{index + 1}</span><span>{group.title}</span></span><span className="award-category-count">{group.awards.length} รางวัล</span><svg className="award-category-chevron" aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></summary>
      <ul>{group.awards.map(awardIndex => {
        const award = specialAwards[awardIndex]
        return <li key={award.name}><h4>{award.provisionalName ? award.name : award.description}</h4><p>{award.provisionalName ? award.description : award.name}</p></li>
      })}</ul>
    </details>)}</div>
  </section>
}
